import {useState} from "react";
import {Stack, Typography} from "@mui/material";
import {appStyles} from "../../../../AppStyles.ts";
import type {ProfileFieldDefinition, ProfileFieldValues} from "../../../../sdo/ProfileFieldDefinition.ts";
import ProfileDetailsForm from "./details/ProfileDetailsForm.tsx";

// TODO: Replace with API call to load IntelDefinition fields from the server.
// Mirrors desktop DefinitionFormBuilder.buildFieldsFormLayout(intelDefinition).
function buildSampleIntelFields(): ProfileFieldDefinition[] {
    return [
        {key: "DISPLAY", label: "Display", hintText: "Display name for the Intel Profile", position: 1, dataType: "STRING", required: true},
        {key: "FULL_NAME", label: "Full Name", hintText: "Legal name on file", position: 2, dataType: "STRING", required: false},
        {key: "ALIASES", label: "Known Aliases", hintText: "One per line, comma-separated, or freeform", position: 3, dataType: "TEXT", required: false},
        {key: "DATE_OF_BIRTH", label: "Date of Birth", hintText: "Best known DOB", position: 4, dataType: "DATE", required: false},
        {
            key: "NATIONALITY",
            label: "Nationality",
            hintText: "Primary nationality of record",
            position: 5,
            dataType: "LIST_ENTRY",
            required: false,
            options: [
                {key: "US", label: "United States"},
                {key: "CA", label: "Canada"},
                {key: "UK", label: "United Kingdom"},
                {key: "AU", label: "Australia"},
                {key: "DE", label: "Germany"},
                {key: "FR", label: "France"},
                {key: "JP", label: "Japan"},
                {key: "OTHER", label: "Other"},
            ],
        },
        {
            key: "CONFIDENCE",
            label: "Confidence Level",
            hintText: "Analyst confidence in source attribution",
            position: 6,
            dataType: "LIST_ENTRY",
            required: true,
            options: [
                {key: "LOW", label: "Low"},
                {key: "MEDIUM", label: "Medium"},
                {key: "HIGH", label: "High"},
                {key: "VERIFIED", label: "Verified"},
            ],
        },
        {key: "DESCRIPTION", label: "Description", hintText: "Free-form analyst notes", position: 7, dataType: "TEXT", required: false},
        {key: "ACTIVE", label: "Active Profile", hintText: "Uncheck to mark as inactive", position: 8, dataType: "BOOLEAN", required: false},
    ];
}

// TODO: Replace with API call to IntelProfileManager.readProfile()
function buildSampleIntelValues(): ProfileFieldValues {
    return {
        DISPLAY: "Sample Intel Subject",
        FULL_NAME: "Jordan Avery Hamilton",
        ALIASES: "J. Hamilton\nAvery Jordan\n\"The Architect\"",
        DATE_OF_BIRTH: "1984-11-22",
        NATIONALITY: "US",
        CONFIDENCE: "MEDIUM",
        DESCRIPTION: "Subject of interest in the March observation window. Confirmed presence at three locations across the city, with corroborating witness statements provided through the partner liaison program.",
        ACTIVE: "true",
    };
}

function UXIntelDetailsPanel() {
    const [fields] = useState<ProfileFieldDefinition[]>(buildSampleIntelFields);
    const [values, setValues] = useState<ProfileFieldValues>(buildSampleIntelValues);

    const handleSave = (updated: ProfileFieldValues) => {
        // TODO: Replace with API call to IntelProfileManager.saveProfile()
        // Mirrors desktop UXIntelDetails.saveProfile() — validates, then calls
        // intelDefinition.create(fields) and profileManager.saveProfile(updatedProfile).
        setValues(updated);
    };

    return (
        <Stack sx={appStyles.defaultPanelContainer} direction="column" padding={1} width="100%">
            {/* Title */}
            <Stack direction="row" padding={1} justifyContent="center">
                <Typography sx={appStyles.panelSectionTitle}>Details</Typography>
            </Stack>

            {/* Editable form */}
            <Stack direction="column" sx={{...appStyles.defaultPanelCardsWrapper, padding: "16px", alignItems: "stretch"}}>
                <ProfileDetailsForm
                    fields={fields}
                    values={values}
                    editable={true}
                    onSave={handleSave}
                />
            </Stack>
        </Stack>
    );
}

export default UXIntelDetailsPanel;
